module.exports = __webpack_public_path__ + "static/img/banner_医院收入运营数据智能体.63c1779b.png";